export default function TabSwitcher({ activeTab, setActiveTab }) {
  return (
    <div className="leaderboard-tabs w-full max-w-sm mx-auto mt-10">
      <div className="relative flex font-mulish bg-gray-400 rounded-lg overflow-hidden">
        <div
          className={`absolute top-0 left-0 w-1/2 h-full bg-black rounded-lg z-0 transition-transform duration-300 ${
            activeTab === "tab2" ? "translate-x-full" : ""
          }`}
        />
        <button
          onClick={() => setActiveTab("tab1")}
          className={`w-1/2 text-center py-1 text-sm font-medium cursor-pointer relative z-10 transition-colors duration-300 text-white`}
        >
          Weekly
        </button>
        <button
          onClick={() => setActiveTab("tab2")}
          className={`w-1/2 text-center py-1 text-sm font-medium cursor-pointer relative z-10 transition-colors duration-300 text-white`}
        >
          Monthly
        </button>
      </div>
    </div>
  );
}
